import { combineReducers } from 'redux';
import { questionsReducer } from './modules/question';
import { userReducer } from './modules/user';

export const rootReducer = combineReducers({
    user: userReducer,
    questions: questionsReducer,
});
export type RootState = ReturnType<typeof rootReducer>;